
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';
import "./MediaPlayer.scss"
import { useGesture } from "@use-gesture/react";
import { animated, useSpring } from "@react-spring/web";

const FullScreenImage = ({ imgUrl, isModalOpen, onClick }) => {

    const ref = useRef(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    // The spring stores the animated values for scale + position
    const [{ x, y, scale }, api] = useSpring(() => ({
        x: 0,
        y: 0,
        scale: 1,
    }));

    // Reset zoom and position when modal opens/closes
    useEffect(() => {
        if (isModalOpen) {
            setImageLoaded(false);
            setImageError(false);
        } else {
            // Reset transformations when modal closes
            api.start({ x: 0, y: 0, scale: 1, immediate: true });
        }
    }, [isModalOpen, api]);

    // Bind gestures
    useGesture(
        {
            onPinch: ({ offset: [s] }) => {
                // Limit scale between 1 and 3
                api.start({ scale: Math.max(1, Math.min(3, s)) });
            },
            onDrag: ({ offset: [dx, dy] }) => {
                api.start({ x: dx, y: dy });
            },
        },
        {
            target: ref,
            eventOptions: { passive: false },
            pinch: { scaleBounds: { min: 1, max: 3 }, rubberband: true },
            drag: { from: () => [x.get(), y.get()] },
        }
    );

    return (isModalOpen && (
        <div className="image-modal" onClick={onClick}
            style={{ touchAction: "none" }}

        >
            {/* Loading state */}
            {!imageLoaded && !imageError && (
                <div className="image-modal__loading">
                    <div className="spinner"></div>
                </div>
            )}

            {/* Error state */}
            {imageError && (
                <div className="image-modal__error">
                    <p>Failed to load image</p>
                </div>
            )}

            <animated.img
                ref={ref}
                src={imgUrl}
                alt=""
                className="image-modal__content"
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageError(true)}
                style={{
                    scale,
                    x,
                    y,
                    touchAction: "none",
                    transformOrigin: "center center",
                    opacity: imageLoaded ? 1 : 0,
                }}
            />
        </div>
    ))
}

FullScreenImage.propTypes = {
    imgUrl: PropTypes.string.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default FullScreenImage;